export default __webpack_public_path__ + "static/media/pixelbay.14665bc6.PNG";